/**
 * 菜单模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取菜单列表
export const menuList = (params) => {
  return req.get('/system/menu/list', params);
}

// 新增菜单
export const menuAdd = (params) => {
  return req.post('/system/menu', params);
}

// 修改菜单信息
export const menuEdit = (params) => {
  return req.put('/system/menu', params);
}

// 删除菜单信息
export const menuDelete = (menuId) => {
  return req.delete(`/system/menu/${menuId}`);
}

// 获取菜单详情
export const menuInfo = (menuId) => {
  return req.get(`/system/menu/${menuId}`);
}